module.exports = __webpack_public_path__ + "img/logo.46050951.svg";